/* VACI referral attribution
   Reads ?ref= from any landing URL, keeps it for 45 days, writes it onto the cart
   as the "Referred by" attribute so it reaches the order for Shopify Flow, then
   applies the friend's discount code.

   Verified on the live store, 2026-08-28:
     - "/collections/all?ref=TOKEN"          -> ref arrives intact
     - "/discount/CODE?redirect=..."         -> applies the code, DROPS extra params
     - "?discount=CODE"                      -> does NOT apply the code at all
   So the link carries ?ref=, we persist it first, and only then hand the browser
   to /discount/ — losing ref from the URL there is harmless once it is stored.

   The referrer is base64url in the link: Shopify decodes ?redirect= exactly once,
   and it keeps the referrer's email out of plaintext in a forwarded link. */
(function () {
  var KEY = 'vaci_ref', SENT = 'vaci_ref_sent', CODED = 'vaci_code_applied',
      DAYS = 45, MAX = 120, CODE = 'VACI2';

  function save(v) {
    try { localStorage.setItem(KEY, JSON.stringify({ v: v, t: Date.now() })); } catch (e) {}
  }
  function load() {
    try {
      var r = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!r || !r.v) return null;
      if (Date.now() - r.t > DAYS * 864e5) { localStorage.removeItem(KEY); return null; }
      return r.v;
    } catch (e) { return null; }
  }
  function param(n) {
    try { return new URLSearchParams(location.search).get(n); } catch (e) { return null; }
  }
  function unb64u(s) {
    try {
      var t = String(s).replace(/-/g, '+').replace(/_/g, '/');
      while (t.length % 4) t += '=';
      var bin = atob(t), b = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) b[i] = bin.charCodeAt(i);
      return new TextDecoder().decode(b);
    } catch (e) { return null; }
  }

  /* Best-effort: attribution must never block or break the sale. */
  function push(ref) {
    try { if (sessionStorage.getItem(SENT) === ref) return Promise.resolve(); } catch (e) {}
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Referred by': ref } })
    }).then(function (res) {
      if (res.ok) { try { sessionStorage.setItem(SENT, ref); } catch (e) {} }
    }).catch(function () {});
  }

  function stripRef() {
    try {
      if (!window.history || !history.replaceState) return;
      var u = new URL(location.href);
      if (!u.searchParams.has('ref')) return;
      u.searchParams.delete('ref');
      history.replaceState({}, '', u.pathname + (u.search || '') + u.hash);
    } catch (e) {}
  }

  /* Once per session only — this navigates, so a loop here would trap the visitor. */
  function applyCode() {
    try {
      if (sessionStorage.getItem(CODED)) return;
      sessionStorage.setItem(CODED, '1');
    } catch (e) { return; }
    var back = location.pathname + (location.search || '') + (location.hash || '');
    location.replace('/discount/' + CODE + '?redirect=' + encodeURIComponent(back));
  }

  function init() {
    var incoming = param('ref'), fresh = false;
    if (incoming) {
      var plain = unb64u(incoming);
      if (!plain || plain.indexOf('@') === -1) plain = incoming;
      save(String(plain).slice(0, MAX));
      stripRef();
      fresh = true;
    }
    var ref = load();
    window.VACI_REF = ref || null;
    if (!ref) return;
    var wrote = push(ref);
    if (fresh) wrote.then(applyCode);   // store and tag first, navigate second
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
